export default __webpack_public_path__ + "static/media/PPI-firefeature-011.5eded44e.jpg";